module.exports = __webpack_public_path__ + "static/media/quiz_image.ef03cdef.svg";